import { previousWeekExtractor } from '../../../data/branchPerformanceData';

function findQuarterInYearData(year, month) {
  for (const key in year) {
    if (typeof year[key] === 'object') {
      if (Object.keys(year[key]).includes(month)) return key;
    }
  }
  return null;
}

export const TransformDate = {
  rawFormatter: (data) => {
    // Initialize the picker array
    const picker = [];
    if (data.length) {
      data.map((entry) => {
        const { fiscal_month, fiscal_quarter, fiscal_week, fiscal_year } = entry;

        if (
          fiscal_month !== null &&
          fiscal_quarter !== null &&
          fiscal_week !== null &&
          fiscal_year !== null
        ) {
          // Find or create the relevant year object in picker
          let yearObj = picker.find((item) => item.currYear === fiscal_year);
          if (!yearObj) {
            yearObj = {
              currYear: fiscal_year,
              Q1: { Dec: [], Jan: [], Feb: [] },
              Q2: { Mar: [], Apr: [], May: [] },
              Q3: { Jun: [], Jul: [], Aug: [] },
              Q4: { Sep: [], Oct: [], Nov: [] },
            };
            picker.push(yearObj);
          }

          // Determine the quarter key (Q1, Q2, Q3, Q4)
          const quarterKey = `Q${fiscal_quarter}`;

          // Determine the month name based on fiscal_month
          const monthNames = [
            'Dec',
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
          ];
          const monthName = monthNames[fiscal_month - 1];
          // Find or create the quarter object within the year object
          if (!yearObj[quarterKey][monthName]) {
            yearObj[quarterKey][monthName] = [];
          }

          // Push the week information into the appropriate array
          yearObj[quarterKey][monthName].push(`w${fiscal_week}`);
        }
      });
    }
    return picker;
  },

  monthMapper: {
    Dec: 1,
    Jan: 2,
    Feb: 3,
    Mar: 4,
    Apr: 5,
    May: 6,
    Jun: 7,
    Jul: 8,
    Aug: 9,
    Sep: 10,
    Oct: 11,
    Nov: 12,
  },

  sortRawFormattedData: (data) => {
    const sortedArr = data && TransformDate.rawFormatter(data);

    if (sortedArr) {
      sortedArr.sort((a, b) => {
        // Sort by current year in descending order
        return b.currYear - a.currYear;
      });

      const monthMap = {
        ...TransformDate.monthMapper,
      };

      sortedArr.forEach((obj) => {
        const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];

        quarters.forEach((quarter) => {
          if (obj[quarter]) {
            const sortedMonths = Object.keys(obj[quarter]).sort((a, b) => {
              const aMonth = monthMap[a];
              const bMonth = monthMap[b];
              return aMonth - bMonth;
            });

            const sortedQuarter = {};
            sortedMonths.forEach((month) => {
              sortedQuarter[month] = obj[quarter][month].sort();
            });

            obj[quarter] = sortedQuarter;
          }
        });
      });
    }
    return sortedArr;
  },

  formatRawDataWithDates: (data) => {
    const result = [];
    if (data.length) {
      data.forEach((entry) => {
        const fiscalYear = entry.fiscal_year;
        const fiscalWeek = entry.fiscal_week;
        const fiscalQuarter = entry.fiscal_quarter;
        const startDate = new Date(entry.start_date).toLocaleDateString('en-US');
        const endDate = new Date(entry.end_date).toLocaleDateString('en-US');

        if (fiscalYear !== null && fiscalWeek !== null && fiscalQuarter !== null) {
          let currentYear = result.find((item) => item.currYear === fiscalYear);

          if (!currentYear) {
            currentYear = {
              currYear: fiscalYear,
              Q1: {},
              Q2: {},
              Q3: {},
              Q4: {},
            };
            result.push(currentYear);
          }

          let quarter;
          if (fiscalQuarter !== null && fiscalQuarter !== undefined) {
            quarter = `Q${fiscalQuarter}`;
          }

          if (quarter && currentYear[quarter]) {
            if (!currentYear[quarter][`w${fiscalWeek}`]) {
              currentYear[quarter][`w${fiscalWeek}`] = {
                start_date: startDate,
                end_date: endDate,
                fiscal_month: entry.fiscal_month, // Add fiscal_month to the result
              };
            }
          }
        }
      });
      // Sort the result array based on currYear
      return result.sort((a, b) => b.currYear - a.currYear);
    }
  },

  isDateInRange: (dateToCheck, startDate, endDate) => {
    const checkDate = new Date(dateToCheck);
    const start = new Date(startDate);
    const end = new Date(endDate);
    return checkDate >= start && checkDate <= end;
  },

  getCurrentYearAndQuarter: (data) => {
    try {
      // Get payload
      const localCachedData = localStorage.getItem('transformDataWithDate');
      let payload = [];

      if (data && data.length > 0) {
        payload = data;
      } else if (localCachedData) {
        try {
          const parsed = JSON.parse(localCachedData);
          payload = parsed.length > 0 ? parsed : [];
        } catch (e) {
          console.error('Error parsing cached data:', e);
          payload = [];
        }
      }

      if (!payload || payload.length === 0) {
        return null;
      }

      // Get previous week object
      const previousWeekObj = previousWeekExtractor(data);

      // Handle week 53 (leap year)
      if (previousWeekObj?.subtractedWeekValue === 53) {
        return {
          year: previousWeekObj.currentYear,
          quarter: 'Q4',
          month: 12,
          week: 'w53',
        };
      }

      // Use previousWeekObj if available
      if (previousWeekObj?.currentYear && previousWeekObj?.subtractedWeekValue) {
        const year = previousWeekObj.currentYear;
        const weekKey = `w${previousWeekObj.subtractedWeekValue}`;

        const yearData = payload.find((obj) => obj?.currYear === year);

        if (yearData) {
          for (const quarter in yearData) {
            if (
              quarter !== 'currYear' &&
              yearData[quarter] &&
              typeof yearData[quarter] === 'object'
            ) {
              const weekData = yearData[quarter][weekKey];
              if (weekData) {
                return {
                  year: year,
                  quarter: quarter,
                  month:
                    weekData.fiscal_month ||
                    Math.min(Math.ceil(previousWeekObj.subtractedWeekValue / 4.33), 12),
                  week: weekKey,
                };
              }
            }
          }
        }
      }

      // Use date range matching
      const currentDate = new Date();
      const formattedCurrentDate = `${currentDate.getMonth() + 1}/${currentDate.getDate()}/${currentDate.getFullYear()}`;

      for (const obj of payload) {
        if (!obj?.currYear) continue;

        const currentYear = obj.currYear;

        for (const quarter in obj) {
          if (quarter !== 'currYear' && obj[quarter] && typeof obj[quarter] === 'object') {
            for (const week in obj[quarter]) {
              const weekData = obj[quarter][week];

              if (weekData?.start_date && weekData?.end_date) {
                if (
                  TransformDate.isDateInRange(
                    formattedCurrentDate,
                    weekData.start_date,
                    weekData.end_date
                  )
                ) {
                  return {
                    year: currentYear,
                    quarter: quarter,
                    month: weekData.fiscal_month,
                    week: week,
                  };
                }
              }
            }
          }
        }
      }

      console.warn('No matching week found');
      return null;
    } catch (error) {
      console.error('Error in getCurrentYearAndQuarter:', error);
      return null;
    }
  },

  getCurrentYear: (year) => {
    if (year === undefined) {
      const currentObj = TransformDate.getCurrentYearAndQuarter();
      const currYear = currentObj && currentObj.year;
      return currYear;
    } else {
      return year;
    }
  },

  getCurrentQuarter: (quarter) => {
    const monthMap = {
      ...TransformDate.monthMapper,
    };
    let currentQuarter = 'Q1';
    if (quarter === undefined) {
      const currentDate = new Date();
      const currentObj = TransformDate.getCurrentYearAndQuarter();
      const monthIndex = (currentObj && currentObj.month) || currentDate.getMonth();
      const currentMonthAbbrev = TransformDate.getMonthAbbreviation(monthIndex);
      const currentMonthNumber = monthMap[currentMonthAbbrev];
      currentQuarter =
        currentMonthNumber >= 4 && currentMonthNumber <= 6
          ? 'Q2'
          : currentMonthNumber >= 7 && currentMonthNumber <= 9
            ? 'Q3'
            : currentMonthNumber >= 10 && currentMonthNumber <= 12
              ? 'Q4'
              : 'Q1';
    } else {
      return quarter;
    }
    return currentQuarter;
  },

  getQuarterData: (quarter = 'Q4', year, transformedData) => {
    const yearData =
      transformedData.length > 0 && transformedData.find((data) => data.currYear == year);
    if (yearData && yearData[quarter]) {
      return yearData[quarter];
    } else {
      return null;
    }
  },

  getMenuItemsForQuarterAndYear: (transformedData) => {
    const quarterSet = new Set();
    const yearSet = new Set();

    if (transformedData) {
      transformedData.forEach((iter) => {
        for (let key in iter) {
          if (key.includes('currYear')) {
            yearSet.add(iter[key]);
          }
          if (key.includes('Q')) {
            quarterSet.add(key);
          }
        }
      });
    }

    const quarters = Array.from(quarterSet);
    const years = Array.from(yearSet);

    return {
      quarters,
      years,
    };
  },

  moveToPrevious: (currentQuarter, currentYear, startingYear) => {
    const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
    const currentQuarterIndex = quarters.indexOf(currentQuarter);

    if (currentYear > startingYear || currentQuarterIndex > 0) {
      if (currentQuarterIndex === 0) {
        return {
          newQuarter: 'Q4',
          newYear: currentYear - 1,
        };
      } else {
        return {
          newQuarter: quarters[currentQuarterIndex - 1],
          newYear: currentYear,
        };
      }
    } else {
      return {
        newQuarter: quarters[currentQuarterIndex],
        newYear: currentYear,
      }; // Reached the boundary, cannot move backward
    }
  },

  moveToNext: (currentQuarter, currentYear, endingYear, endingQuarter) => {
    const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
    const currentQuarterIndex = quarters.indexOf(currentQuarter);
    const endingQuarterIndex = quarters.indexOf(endingQuarter);

    if (
      currentYear < endingYear ||
      (currentYear === endingYear &&
        currentQuarterIndex < endingQuarterIndex &&
        currentQuarterIndex < 3)
    ) {
      if (currentQuarterIndex === 3) {
        return {
          newQuarter: 'Q1',
          newYear: currentYear + 1,
        };
      } else {
        return {
          newQuarter: quarters[currentQuarterIndex + 1],
          newYear: currentYear,
        };
      }
    } else {
      return {
        newQuarter: quarters[currentQuarterIndex],
        newYear: currentYear,
      }; // Reached the boundary, cannot move forward
    }
  },

  // Function to get the month abbreviation based on the index
  getMonthAbbreviation: (index) => {
    const monthNames = [
      'Dec',
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
    ];
    return monthNames[index - 1];
  },

  getBoundaryValues: (payload) => {
    if (payload && Object.keys(payload).length) {
      const data = [...payload.transformData];
      const lastObj = data[data.length - 1];
      const startingYear = lastObj.currYear;
      const obj = TransformDate.getCurrentYearAndQuarter(payload.transformDataWithDate);
      let foundYear;
      if (payload.transformDataWithDate && payload.transformDataWithDate.length > 0) {
        const dataArray = payload.transformDataWithDate;
        foundYear =
          payload?.current_year ||
          dataArray.find((item) => item.currYear > new Date().getFullYear());
      }
      let endingYear;
      if (foundYear && Object.keys(foundYear).length) {
        endingYear = foundYear.currYear || new Date().getFullYear();
      } else {
        endingYear = (obj && obj.year) || new Date().getFullYear();
      }
      const monthMap = {
        ...TransformDate.monthMapper,
      };
      const currentDate = new Date();
      const monthIndex = (obj && obj.month) || currentDate.getMonth();
      const currentMonthAbbrev = TransformDate.getMonthAbbreviation(monthIndex);
      const currentMonthNumber = monthMap[currentMonthAbbrev];
      const endingQuarter =
        currentMonthNumber >= 4 && currentMonthNumber <= 6
          ? 'Q2'
          : currentMonthNumber >= 7 && currentMonthNumber <= 9
            ? 'Q3'
            : currentMonthNumber >= 10 && currentMonthNumber <= 12
              ? 'Q4'
              : 'Q1';
      return {
        startingYear,
        endingYear,
        endingQuarter,
      };
    }
  },

  getCurrentMonthRange: (data, year, transformedDataWithDate) => {
    const obj =
      transformedDataWithDate && TransformDate.getCurrentYearAndQuarter(transformedDataWithDate);
    const currMonth = obj && obj.month;
    const monthMap = {
      ...TransformDate.monthMapper,
    };
    const monthName = Object.keys(monthMap)[currMonth - 1];
    let yearObj = data.find((obj) => obj.currYear === year);
    const currentQuarter = findQuarterInYearData(yearObj, monthName);
    if (data.length && year) {
      const weekRange = data.map((iter) => {
        if (iter.currYear === year) {
          return iter[currentQuarter][monthName];
        }
      });
      const range = weekRange.filter((item) => item !== undefined);
      return range[0];
    }
  },

  getNumberFromString: (week) => {
    return parseInt(week?.match(/\d+/)[0]);
  },

  dateFormatter: (value) => {
    const date = new Date(value);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  },

  getLastQuarter: (data) => {
    const monthMap = {
      ...TransformDate.monthMapper,
    };
    const obj = data && TransformDate.getCurrentYearAndQuarter(data);
    const currentDate = new Date();
    const monthIndex = (obj && obj.month) || currentDate.getMonth();
    const currentMonthAbbrev = TransformDate.getMonthAbbreviation(monthIndex);
    const currentMonthNumber = monthMap[currentMonthAbbrev];

    const currentQuarter = Math.ceil(currentMonthNumber / 3);
    const lastQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1;
    const convertedQuarter = `Q${lastQuarter}`;
    return convertedQuarter;
  },
  getCurrentQuarterBasedOnWeek: (startingWeek, data) => {
    const quarter = Object.keys(data).find((qtr) => data[qtr].hasOwnProperty(startingWeek));
    return quarter || null;
  },
  isLeapYear: (year) => {
    const lastYear = year;
    return (lastYear % 4 === 0 && lastYear % 100 !== 0) || lastYear % 400 === 0;
  },
  findDifferenceBetweenWeeks: (data) => {
    // plus 1 added to get the preceding weeks
    if (data?.start_week > data?.end_week) {
      const startWeekSubtractedValue = TransformDate?.isLeapYear(data?.start_year)
        ? 53 - data?.start_week
        : 52 - data?.start_week;
      return startWeekSubtractedValue + data?.end_week + 1;
    } else if (data?.start_week < data?.end_week) {
      return data?.end_week - data?.start_week + 1;
    }
  },
  precedingPreviovsWeek: (data, subtractionValue = 1) => {
    let weekDataObj = {};
    // the input year should be current year -1 as we will compare current year data with last year weeks
    const numberOfWeeksForStartYear = TransformDate?.isLeapYear(data?.start_year - 1) ? 53 : 52;
    const numberOfWeeksForEndYear = TransformDate?.isLeapYear(data?.end_year - 1) ? 53 : 52;
    const startWeekValueAfterSubtraction = data?.start_week - subtractionValue;
    const endWeekValueAfterSubtraction = data?.end_week - subtractionValue;

    // - - = + hence + added for the subtraction in return for numberOfWeeks + weekValueAfterSubtraction
    if (startWeekValueAfterSubtraction <= 0) {
      Object.assign(weekDataObj, {
        start_week: numberOfWeeksForStartYear + startWeekValueAfterSubtraction || 1,
        start_year: data?.start_year - 1,
      });
    } else {
      Object.assign(weekDataObj, {
        start_week: startWeekValueAfterSubtraction,
        start_year: data?.start_year,
      });
    }

    if (endWeekValueAfterSubtraction <= 0) {
      Object.assign(weekDataObj, {
        end_week: numberOfWeeksForEndYear + endWeekValueAfterSubtraction,
        end_year: data?.end_year - 1,
      });
    } else {
      Object.assign(weekDataObj, {
        end_week: endWeekValueAfterSubtraction,
        end_year: data?.end_year,
      });
    }
    return weekDataObj;
  },
  getDerivedObject: (data) => {
    const derivedObj = [];

    data.forEach((item) => {
      const newObj = {
        currYear: item.currYear,
      };

      for (const quarter in item) {
        if (quarter !== 'currYear') {
          const quarterData = item[quarter];
          const flattenedMonths = Object.values(quarterData).flat();
          newObj[quarter] = flattenedMonths;
        }
      }

      derivedObj.push(newObj);
    });
    return derivedObj;
  },

  getSelectedRange: (data, input) => {
    const derivedObj = TransformDate.getDerivedObject(data);
    let startYear, endYear, startWeek, endWeek, startQuarter, endQuarter;
    const inputs = [];
    if (input.length) {
      for (const obj of input) {
        const currYear = obj.currYear;
        for (const quarter in obj) {
          if (quarter !== 'currYear') {
            for (const month in obj[quarter]) {
              const weekValues = obj[quarter][month];
              for (const week of weekValues) {
                inputs.push(week, quarter, currYear);
              }
            }
          }
        }
      }
    }

    if (inputs.length) {
      const weekOnePositionCheck = parseInt(inputs[0]?.split('w')?.join(''));
      const weekTwoPositionCheck = inputs[3]?.split('w')?.join('');

      const shouldSwap =
        (weekOnePositionCheck <= weekTwoPositionCheck && inputs[2] > inputs[inputs.length - 1]) ||
        (weekOnePositionCheck >= weekTwoPositionCheck && inputs[2] > inputs[inputs.length - 1]) ||
        (weekOnePositionCheck > weekTwoPositionCheck && inputs[2] === inputs[inputs.length - 1]);

      if (shouldSwap) {
        [inputs[0], inputs[3], inputs[1], inputs[4], inputs[2], inputs[5]] = [
          inputs[3],
          inputs[0],
          inputs[4],
          inputs[1],
          inputs[5],
          inputs[2],
        ];
      }

      startYear = inputs[2];
      startQuarter = inputs[1];
      startWeek = inputs[0];

      endYear = inputs[inputs.length - 1];
      endQuarter = inputs[4];
      endWeek = inputs[3];
    }

    if (endWeek === undefined && endQuarter === undefined) {
      endWeek = startWeek;
      endQuarter = startQuarter;
    }

    const arr = [];

    derivedObj.forEach((quarterObj) => {
      const currYear = quarterObj.currYear;
      if (currYear === startYear && currYear === endYear) {
        const currYearObj = { ...quarterObj };
        for (const obj in currYearObj) {
          if (obj > endQuarter && obj !== 'currYear') {
            delete currYearObj[obj];
          }
          if (obj < startQuarter && obj !== 'currYear') {
            delete currYearObj[obj];
          }
          if (obj === startQuarter) {
            const q1Array = currYearObj[obj];
            const startIndex = q1Array.indexOf(startWeek);
            if (startIndex !== -1) {
              currYearObj[obj] = q1Array.slice(startIndex);
            }
          }
          if (obj === endQuarter) {
            const endIndex = currYearObj[obj].indexOf(endWeek);
            if (endIndex !== -1) {
              currYearObj[obj] = currYearObj[obj].slice(0, endIndex + 1);
            }
          }
        }
        arr.push(currYearObj);
      } else {
        if (currYear === startYear) {
          const currYearObj = { ...quarterObj };
          for (const obj in currYearObj) {
            if (obj < startQuarter && obj !== 'currYear') {
              delete currYearObj[obj];
            }
            if (obj === startQuarter) {
              const q1Array = currYearObj[obj];
              const startIndex = q1Array.indexOf(startWeek);
              if (startIndex !== -1) {
                currYearObj[obj] = q1Array.slice(startIndex);
              }
            }
          }
          arr.push(currYearObj);
        }
        if (currYear === endYear) {
          const endYearObj = quarterObj; // Create a copy of the object
          for (const obj in endYearObj) {
            if (obj === endQuarter) {
              const endIndex = endYearObj[obj].indexOf(endWeek);
              if (endIndex !== -1) {
                endYearObj[obj] = endYearObj[obj].slice(0, endIndex + 1);
              }
            }
            if (obj > endQuarter && obj !== 'currYear') {
              delete endYearObj[obj];
            }
          }
          arr.push(endYearObj);
        }
      }
    });

    return arr;
  },

  preDefinedWeekRange: (data) => {
    const arr = [];

    const { start_week, start_year, end_week, end_year } = data;

    let currentYear = start_year;
    let currentWeek = start_week;
    let quarterData = {};

    while (currentYear <= end_year) {
      const quarterKey = `Q${Math.ceil(currentWeek / 13)}`;

      if (!quarterData[quarterKey]) {
        quarterData[quarterKey] = [];
      }

      const weekIdentifier = `w${currentWeek}`;
      quarterData[quarterKey].push(weekIdentifier);

      currentWeek++;

      if (end_year > currentYear && currentWeek <= 52) {
        continue;
      }

      if (currentWeek > end_week) {
        if (Object.keys(quarterData).length > 0) {
          arr.push({
            currYear: currentYear,
            ...quarterData,
          });

          quarterData = {};
          currentYear++;
          currentWeek = 1;
        }
      }
    }

    return arr;
  },

  getKeysFromObj: (data) => {
    if (data.length) {
      const obj = data[0];
      const keys = Object.keys(obj);
      const key = keys.find((key) => key.startsWith('Q'));
      const arr = [];
      arr.push(key, obj.currYear);
      return arr;
    }
  },

  findQuarter: (year, week, data) => {
    for (const item of data) {
      if (item.currYear === year) {
        for (const quarter in item) {
          if (quarter !== 'currYear') {
            for (const month in item[quarter]) {
              if (item[quarter][month].includes(`w${week}`)) {
                return quarter;
              }
            }
          }
        }
      }
    }
    return 'Quarter not found';
  },

  getWeeksBefore: (inputWeek, weeks) => {
    const index = weeks.indexOf(inputWeek);
    if (index === -1) {
      // Week not found in the array
      return [];
    } else if (index === 0) {
      // If input is w1, return w1
      return [weeks[0]];
    } else {
      // Return all weeks before the given week
      return weeks.slice(0, index);
    }
  },

  quickFilters: {
    // TODO: Need to get the dates for each fiscal week, in order to determine the current week
    LAST_WEEK: (data) => {
      const currentYear = new Date().getFullYear();
      if (data.length) {
        const currentMonthWeeks = TransformDate.getCurrentMonthRange(data, currentYear);
        const lastWeek = currentMonthWeeks[currentMonthWeeks.length - 2];
        return {
          start_week: TransformDate?.getNumberFromString(lastWeek),
          start_year: currentYear,
          end_week: TransformDate?.getNumberFromString(lastWeek),
          end_year: currentYear,
        };
      }
    },
    LAST_MONTH: (data, year, transformedDataWithDate) => {
      // const currMonth = new Date().getMonth() + 1 // Not using +1 as months are 0 based
      const monthMap = {
        ...TransformDate.monthMapper,
      };
      const obj =
        transformedDataWithDate && TransformDate.getCurrentYearAndQuarter(transformedDataWithDate);
      const currentDate = new Date();
      const monthIndex = (obj && obj.month) || currentDate.getMonth();
      const currentMonthAbbrev = TransformDate.getMonthAbbreviation(monthIndex);
      const currentMonthNumber = monthMap[currentMonthAbbrev];
      let lastMonth;
      let startYear = year;
      let endYear = year;
      if (currentMonthNumber === 1) {
        lastMonth = 12;
        startYear = year - 1;
        endYear = year - 1;
      } else {
        lastMonth = currentMonthNumber - 1;
      }
      const monthName = Object.keys(monthMap)[lastMonth - 1];

      const currentQuarter =
        lastMonth >= 4 && lastMonth <= 6
          ? 'Q2'
          : lastMonth >= 7 && lastMonth <= 9
            ? 'Q3'
            : lastMonth >= 10 && lastMonth <= 12
              ? 'Q4'
              : 'Q1';

      if (data.length) {
        const weekRange = data.map((iter) => {
          if (iter.currYear === year) {
            return iter[currentQuarter][monthName];
          }
        });
        const range = weekRange.filter((item) => item !== undefined);
        return {
          start_week: TransformDate.getNumberFromString(range[0][0]),
          start_year: startYear,
          end_week: TransformDate.getNumberFromString(range[0].slice(-1)[0]),
          end_year: endYear,
        };
      }
    },
    LAST_QUARTER: (data, currentYear, transformedDataWithDate, previousQuarter) => {
      const currentQuarter = 1;
      const lastQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1;
      const convertedQuarter = `Q${previousQuarter !== 0 ? previousQuarter : lastQuarter}`;
      let startWeek, endWeek, startYear, endYear;
      if (data.length) {
        data.forEach((iter) => {
          if (iter[convertedQuarter] && iter.currYear === currentYear) {
            const quarter = iter[convertedQuarter];
            const months = Object.keys(iter[convertedQuarter]);
            const [startMonth, ...restMonths] = months;
            const endMonth = restMonths.pop();
            startWeek = quarter[startMonth][0];
            endWeek = quarter[endMonth][quarter[endMonth].length - 1];
            startYear = currentYear;
            endYear = currentYear;
          }
        });
      }
      const obj = {
        start_week: TransformDate.getNumberFromString(startWeek),
        start_year: startYear,
        end_week: TransformDate.getNumberFromString(endWeek),
        end_year: endYear,
      };

      return obj;
    },
    LAST_YEAR: (data, current_year) => {
      const obj = data && TransformDate.getCurrentYearAndQuarter(data);
      const currentYear = current_year || (obj && obj.year) || new Date().getFullYear();
      const lastYear = currentYear - 1;
      const isLastYearLeap = TransformDate.isLeapYear(lastYear);

      const startWeek = 1;
      const startYear = lastYear;

      const endWeek = isLastYearLeap ? 53 : 52;
      const endYear = lastYear;

      return {
        start_week: startWeek,
        start_year: startYear,
        end_week: endWeek,
        end_year: endYear,
      };
    },
    YTD: (data, transformedDataWithDate) => {
      const obj =
        transformedDataWithDate && TransformDate.getCurrentYearAndQuarter(transformedDataWithDate);
      const currentDate = new Date();
      const currentYear = (obj && obj.year) || currentDate.getFullYear();
      const yearData = data.find((item) => item.currYear === currentYear);
      if (!yearData) {
        return [];
      }
      const monthObjects = Object.values(yearData).slice(1);
      const weekArrays = monthObjects.flatMap((month) => Object.values(month).flat());
      const weeksUpToLastWeek = obj && TransformDate.getWeeksBefore(obj.week, weekArrays);
      return {
        start_week:
          (weeksUpToLastWeek && TransformDate.getNumberFromString(weeksUpToLastWeek[0])) || 1,
        start_year: currentYear,
        end_week:
          (weeksUpToLastWeek &&
            TransformDate.getNumberFromString(weeksUpToLastWeek[weeksUpToLastWeek.length - 1])) ||
          2,
        end_year: currentYear,
      };
    },
    YEAR_TO_DATE: (transformedDataWithDate, previousWeekExtractor) => {
      // current fiscal week doesn't have data hence sutracting -1
      const currentWeekAndYearObj = previousWeekExtractor(transformedDataWithDate);
      return {
        start_week: 1,
        start_year: currentWeekAndYearObj?.currentYear,
        end_week: currentWeekAndYearObj?.subtractedWeekValue,
        end_year: currentWeekAndYearObj?.currentYear,
      };
    },
    CUSTOM: (data) => {
      let minYear = Number.MAX_SAFE_INTEGER;
      let maxYear = Number.MIN_SAFE_INTEGER;
      let minWeek = 'W52';
      let maxWeek = 'W00';

      data.forEach((item) => {
        const year = item.currYear;
        const quarters = Object.keys(item).filter((key) => key.startsWith('Q'));

        quarters.forEach((quarter) => {
          item[quarter].forEach((week) => {
            const weekNumber = parseInt(week.substring(1));
            if (
              year < minYear ||
              (year === minYear && weekNumber < parseInt(minWeek.substring(1)))
            ) {
              minYear = year;
              minWeek = week;
            }
            if (
              year > maxYear ||
              (year === maxYear && weekNumber > parseInt(maxWeek.substring(1)))
            ) {
              maxYear = year;
              maxWeek = week;
            }
          });
        });
      });
      const result = {
        start_week: TransformDate.getNumberFromString(minWeek),
        start_year: minYear,
        end_week: TransformDate.getNumberFromString(maxWeek),
        end_year: maxYear,
      };

      return result;
    },
    TWELVE_WEEK_DATA: (data, previousWeekExtractor, weekToBeSubtracted) => {
      // -1 because the current fiscal week has no data
      const dataForCurrentWeek = previousWeekExtractor(data);
      const dataForPreviousWeek = previousWeekExtractor(data, weekToBeSubtracted);
      // currentYear, || 1 and || 12  is added to default the values in case of nodata or  data issue
      const currentYear = new Date().getFullYear();
      return {
        start_week: dataForPreviousWeek?.subtractedWeekValue,
        start_year: dataForPreviousWeek?.currentYear || currentYear,
        end_week: dataForCurrentWeek?.subtractedWeekValue,
        end_year: dataForCurrentWeek?.currentYear || currentYear,
      };
    },
  },

  comparisonPeriod: {
    previousPeriod: (data) => {
      if (data?.start_year === 2019) {
        return {
          start_week: data?.start_week,
          start_year: data?.start_year,
          end_week: data?.end_week,
          end_year: data?.end_year,
        };
      }
      return {
        start_week:
          !TransformDate.isLeapYear(data?.start_year - 1) && data?.start_week === 53
            ? 52
            : data?.start_week,
        start_year: data?.start_year - 1,
        end_week: data?.end_week,
        end_year: data?.end_year - 1,
      };
    },
    precedingPreviousPeriod: (selectedWeeks) => {
      const subtractionValue = TransformDate.findDifferenceBetweenWeeks(selectedWeeks);
      // edge case data is starting from year 2019
      if (selectedWeeks?.start_year === 2019 && selectedWeeks?.start_week - subtractionValue <= 0) {
        return selectedWeeks;
      }

      return TransformDate?.precedingPreviovsWeek(selectedWeeks, subtractionValue);
    },
    previousPeriodYTD: (data) => {
      if (data?.start_year === 2019) {
        return {
          start_week: data?.start_week,
          start_year: data?.start_year,
          end_week: 52,
          end_year: data?.end_year,
        };
      }
      return {
        start_week: data?.start_week,
        start_year: data?.start_year - 1,
        end_week: 52,
        end_year: data?.end_year - 1,
      };
    },
    previousFilter: (data) => {
      if (data?.start_year === 2019) {
        return {
          start_week: data?.start_week,
          start_year: data?.start_year,
          end_week: data?.end_week,
          end_year: data?.end_year,
        };
      }
      return {
        start_week:
          !TransformDate.isLeapYear(data?.start_year - 1) && data?.start_week === 53
            ? 52
            : data?.start_week,
        start_year: data?.start_year - 1,
        end_week: data?.end_week,
        end_year: data?.end_year - 1,
      };
    },
    previousYear: (data) => {
      if (data?.start_year === 2019) {
        return {
          start_week: data?.start_week,
          start_year: data?.start_year,
          end_week: data?.end_week,
          end_year: data?.end_year,
        };
      }
      return {
        start_week: data?.start_week === 1 ? data?.start_week : data?.start_week - 1,
        start_year: data?.start_year - 1,
        end_week: data?.end_week - 1,
        end_year: data?.end_year - 1,
      };
    },
  },

  getSortedMonthData: (data) => {
    if (data === undefined) {
      return data;
    }

    // Define a custom order for months
    const monthOrder = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      Jun: 6,
      Jul: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };

    // Get the keys (month abbreviations) and sort them based on the custom order
    const sortedKeys = Object.keys(data).sort((a, b) => {
      const orderA = monthOrder[a] || Infinity; // Get the custom order value or default to Infinity
      const orderB = monthOrder[b] || Infinity;
      return orderA - orderB; // Sort based on custom order
    });

    // Create a new object with sorted keys
    const sortedData = {};
    sortedKeys.forEach((key) => {
      sortedData[key] = data[key];
    });

    return sortedData;
  },

  sortOnKeys: (dict) => {
    const sortedKeys = Object.keys(dict).sort((a, b) => a.localeCompare(b));
    return sortedKeys.reduce((acc, key) => {
      acc[key] = dict[key];
      return acc;
    }, {});
  },

  sortByYear: (data) => {
    let _data = [];

    if (data?.length > 1 && data[0]['currYear'] > data[1]['currYear']) {
      _data[0] = data[1];
      _data[1] = data[0];

      return _data;
    }
    return data;
  },
  currentQuarterExtractor: (data) => {
    try {
      if (!data || data.length === 0) return null;
      const previousWeekObj = previousWeekExtractor(data);
      // Check if first year in array matches current year
      const firstYearInData = data[0]?.currYear;
      const currentYearFromExtractor = previousWeekObj?.currentYear;

      if (firstYearInData === currentYearFromExtractor && previousWeekObj?.currentWeek) {
        const weekKey = `w${previousWeekObj.currentWeek}`;
        const yearData = data[0];

        for (const quarter of Object.keys(yearData)) {
          if (quarter !== 'currYear' && yearData[quarter]?.[weekKey]) {
            return quarter;
          }
        }
      }
      return null;
    } catch (error) {
      return null;
    }
  },
  filterQuarters: (inputQuarter, quarters) => {
    const index = quarters.indexOf(inputQuarter);
    if (index === -1) {
      return [];
    }
    return quarters?.slice(0, index + 1);
  },
  valueGreaterThanCurrWeek(weekValue, numericValue) {
    const weekNumber = parseInt(weekValue.substring(1));
    const numericWeek = parseInt(numericValue);
    return weekNumber > numericWeek;
  },

  // Check if Q5 is present and merge its weeks into Q4
  mergeQ5IntoQ4: (arr) => {
    arr.forEach((item) => {
      if (item.Q5) {
        item.Q4 = [...(item.Q4 || []), ...item.Q5];
        delete item.Q5;
      }
    });
    return arr;
  },

  getEndWeek: (endWeek, endYear) => {
    if (endWeek === 53) {
      return endWeek === 53 && TransformDate?.isLeapYear(endYear) ? 53 : 52;
    } else return null;
  },

  addWeek53ToLeapYearQ4: (weeksData) => {
    return weeksData?.map((item, index, array) => {
      const { currYear, Q4 = [], Q5 = [] } = item || {};
      const nextItem = array?.[index + 1];

      // Check if Q4 exists and the year is a leap year
      if (
        Q4 &&
        new Date(currYear, 1, 29).getMonth() === 1 &&
        nextItem &&
        nextItem.currYear === currYear + 1
      ) {
        if (!Q4.includes('w53')) {
          Q4.push('w53');
        }
      }

      // Check if Q5 exists and contains w53, then add it to Q4
      if (Q5?.includes('w53') && !Q4?.includes('w53')) {
        Q4?.push('w53');
      }

      // Ensure Q4 is updated in the returned object
      return { ...item, Q4 };
    });
  },
};
